@if (!isLoading) {
<div class="flex justify-end mb-2">
  <button (click)="toggleSelectionMode()"
    class="text-sm font-medium px-3 py-1 rounded-full transition-colors"
    [class.text-primary]="!isSelectionMode"
    [class.text-red-500]="isSelectionMode">
    {{ (isSelectionMode ? 'garden.selection.cancel' : 'garden.selection.select') | translate }}
  </button>
</div>
<div class="flex gap-y-4 flex-wrap -mx-2 h-full">
  @for (hierarchy of userHierarchies; track hierarchy) {
  <div class="w-2/4 h-full relative" (click)="onHierarchyClicked(hierarchy)">
    <vw-hierarchy-item [hierarchy]="hierarchy"></vw-hierarchy-item>
    @if (isSelectionMode) {
    <div class="absolute top-2 right-4 z-10">
      <div class="w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors"
        [class.border-primary]="isSelected(hierarchy)"
        [class.bg-primary]="isSelected(hierarchy)"
        [class.border-grey-300]="!isSelected(hierarchy)"
        [class.bg-white]="!isSelected(hierarchy)">
        @if (isSelected(hierarchy)) {
        <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
        </svg>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
}
@if (isLoading) {
<div class="grid grid-cols-2 gap-8">
  @for (i of [1,2]; track i) {
  <vw-skeleton-loader [width]="'100%'" [height]="'200px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
  }
</div>
}

@if (isSelectionMode && selectedHierarchyUids.size > 0) {
<div class="fixed bottom-0 left-0 right-0 z-[9999] px-4 pb-4">
  <div class="bg-white rounded-t-xl shadow-[0_-4px_12px_rgba(0,0,0,0.1)] p-4 relative">
    <button (click)="toggleSelectionMode()" class="absolute top-3 right-3 text-grey-500 hover:text-grey-700">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
    <div class="flex justify-center pt-2">
      <button (click)="confirmDelete()" [disabled]="isDeleting"
        class="flex items-center gap-2 px-6 py-3 bg-red-500 hover:bg-red-700 active:bg-red-800 text-white font-medium rounded-full transition-colors disabled:opacity-70">
        @if (isDeleting) {
        <span>{{ 'garden.selection.deleting' | translate }}</span>
        } @else {
        <span>{{ 'garden.selection.delete' | translate: { count: selectedHierarchyUids.size } }}</span>
        }
      </button>
    </div>
  </div>
</div>
}

<vw-modal [isOpen]="isConfirmDeleteOpen" [width]="'90%'" [height]="'auto'" [showCloseIcon]="false"
  [customClasses]="'rounded-xl'" (close)="cancelDelete()">
  <div modalHeader>
    <h2 class="text-[#0C0D0D] text-lg font-semibold">{{ 'garden.selection.confirm_title' | translate }}</h2>
  </div>
  <div modalBody>
    <p class="text-grey-600 text-sm py-4">{{ 'garden.selection.confirm_message' | translate: { count: selectedHierarchyUids.size } }}</p>
  </div>
  <div modalFooter>
    <div class="flex gap-3 justify-end pb-2">
      <button (click)="cancelDelete()"
        class="px-4 py-2 text-sm font-medium text-grey-700 bg-grey-100 hover:bg-grey-200 rounded-lg transition-colors">
        {{ 'garden.selection.cancel' | translate }}
      </button>
      <button (click)="deleteSelected()"
        class="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-700 rounded-lg transition-colors">
        {{ 'garden.selection.confirm_delete' | translate }}
      </button>
    </div>
  </div>
</vw-modal>

<vw-hierarchy-items-choice-modal [isOpen]="isModalOpen" [hierarchy]="selectedHierarchy"
  (onCultivationSelected)="onCultivationSelected(selectedHierarchy, $event)" (onModalClosed)="onModalClosed()">
</vw-hierarchy-items-choice-modal>